<template>
    <!-- 认定 -->
    <div style="padding: 10px;display: flex;width: 1200px;margin: 0 auto;position: relative;top:100px">
        <div class="site-tree">
            <ul class="layui-tree" style="font-size: 16px;">
                <li style="margin-bottom: 29px;height: 60px;line-height: 60px;">
                    <h2
                        style="border-left:5px solid #049be2;border-left: 5px solid #049be2;height: 60px;font-size: 20px;line-height: 60px;">
                        认定申报</h2>
                </li>
                <li class="site-tree-noicon" v-for="(data,index) in lilist" @click="leftBeginAffirm(index)">
                    <router-link :to="data.url" :class="data.state == 2?'ac':''"
                        style="display: inline-block;width: 100%;color: #777;cursor: pointer;">
                        <cite>{{data.name}}</cite>
                    </router-link>
                </li>
            </ul>
        </div>
        <router-view class="site-content"></router-view>
    </div>
</template>
<script>

    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                lilist: [],
                lilist1: [
                    { name: '首页', state: 2, url: '/beginHomePage/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '认定说明', state: 1, url: '/affirmExplain' },
                    { name: '个人信息', state: 1, url: '/personalInformation/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '开始认定', state: 1, url: '/beginAffirm/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '上传资料', state: 1, url: '/affirmUploadData/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '取消认定', state: 1, url: '/affirmcancel/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '认定缴费', state: 1, url: '/affirmPayTheFees/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '培训缴费', state: 1, url: '/trainPayTheFees/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '我的认定', state: 1, url: '/affirmrecord/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '修改密码', state: 1, url: '/affirmChangePassword' },
                    { name: '消息通知', state: 1, url: '/affirmMessageNotification' },
                    { name: '职业标准', state: 1, url: '/affirmProfessionalStandard/' + this.$route.params.workTypeLevelState }
                ],
                lilist2: [
                    { name: '首页', state: 2, url: '/beginHomePage1/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '认定说明', state: 1, url: '/affirmExplain1' },
                    { name: '个人信息', state: 1, url: '/personalInformation1/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '开始认定', state: 1, url: '/beginAffirm1/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '上传资料', state: 1, url: '/affirmUploadData1/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '取消认定', state: 1, url: '/affirmcancel1/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '认定缴费', state: 1, url: '/affirmPayTheFees1/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    // {name:'培训缴费',state:1,url:'/trainPayTheFees1/'+this.$route.params.workTypeLevelState+"/"+this.$route.params.state},
                    { name: '我的认定', state: 1, url: '/affirmrecord1/' + this.$route.params.workTypeLevelState + "/" + this.$route.params.state },
                    { name: '修改密码', state: 1, url: '/affirmChangePassword1' },
                    { name: '消息通知', state: 1, url: '/affirmMessageNotification1' },
                    { name: '职业标准', state: 1, url: '/affirmProfessionalStandard1/' + this.$route.params.workTypeLevelState }
                ],
            }
        },
        created() {
            if (this.$route.params.state == 1) {
                this.lilist = this.lilist1;
            } else {
                this.lilist = this.lilist2;
            }
        },
        mounted() {

        },
        methods: {
            //点击样式切换
            leftBeginAffirm(index) {
                this.lilist.forEach(element => {
                    if (element.state == 2) {
                        element.state = 1;
                    }
                });
                this.lilist[index].state = 2;
            }
        }
    }
</script>

<style scoped>
    .site-content {
        width: 954px;
        min-height: 900px;
        padding: 20px 0 10px 20px;
    }

    .site-tree {
        padding: 0 0 11px;
        width: 210px;
        padding-right: 10px;
        border-right: 1px solid #eee;
    }

    .layui-tree {
        line-height: 32px;
    }

    .layui-tree li:not(:first-child) {
        border-bottom: 1px solid #f2f2f2;
    }

    .layui-tree li {
        height: 45px;
        line-height: 45px;
    }

    .site-tree .layui-tree li h2 {
        line-height: 36px;
        border-left: 5px solid #009E94;
        margin: 15px 0 5px;
        padding: 0 10px;
        background-color: #f2f2f2;
    }

    .ac {
        border-left: 5px solid #f08326;
        background-color: #f2f2f2;
    }

    .site-tree .layui-tree .site-tree-noicon a cite {
        padding-left: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/components/affirm/affirm.vue